import { SxProps, Theme } from "@mui/material";

export const textFieldStyles: SxProps<Theme> = {
  "& input:-webkit-autofill": {
    WebkitTextFillColor: "#fff",
    caretColor: "#fff",
    transition: "background-color 5000s ease-in-out 0s",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#ffffff83",
    },
    "&:hover fieldset": {
      borderColor: "#ffffffe0",
    },

    "&.Mui-focused fieldset": {
      borderColor: "#ffffffe0",
    },
  },
};

export const submitButtonStyles: SxProps<Theme> = {
  textTransform: "none",
  borderRadius: 24,
  mt: 2,
  color: "#222",
  fontWeight: 600,
  background: "linear-gradient(90deg, #00FFB0 0%, #00E0FF 100%)",
  "&.Mui-disabled": {
    background: "#bfc9d1",
    color: "#00000026",
  },
};

export const backButtonStyles: SxProps<Theme> = {
  color: "#bfc9d1",
  fontSize: "17px",
  mt: 14,
  ml: 0,
  textAlign: "left",
  p: 0,
  minWidth: 0,
  alignSelf: "flex-start",
  textTransform: "none",
  "&:hover": {
    color: "#fff",
    background: "none",
  },
};
